var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loaderSend"},[_c('b-icon',{attrs:{"icon":"envelope-fill","animation":"cylon","font-scale":"4"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }